import React, { useState, useEffect } from 'react';
import { DateTime } from 'luxon';
import { Grid2, Box, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MoneyFormattedUtils, TimeDurationFormatter } from '../../../../utils';

interface Slot {
  start: string;
  startUTC: string;
  endUTC: string;
  end: string;
  timezone: string;
  currency: string;
  available: boolean;
  price?: string | number;
  id: number;
  duration: number;
}

interface SlotsProps {
  slot: Slot[];
  quantity: number;
  daySelected: string;
  experience?: any;
  setSelectedSlot: (slot: SelectedSlot) => void;
}

interface SelectedSlot extends Slot {
  priceTotal?: string | number;
  timeOfArrivalFormatted?: string;
}

const Slots: React.FC<SlotsProps> = ({
  slot,
  quantity,
  daySelected,
  experience,
  setSelectedSlot,
}) => {
  const { t: translate, i18n } = useTranslation();
  const [selectedSlotIndex, setSelectedSlotIndex] = useState<number | null>(
    null
  );

  useEffect(() => {
    setSelectedSlotIndex(null);
  }, [experience, daySelected, quantity]);

  if (!slot || !Array.isArray(slot)) {
    return null;
  }

  const selectedSlots =
    slot.filter((slot) => daySelected === slot.start?.substring(0, 10)) || [];

  const handleSelectSlot = ({ index, item }: { index: number; item: Slot }) => {
    if (!item.available) {
      return;
    }
    setSelectedSlotIndex(index);
    setSelectedSlot({
      ...item,
      priceTotal: item.price ? item.price as number * quantity : undefined,
      timeOfArrivalFormatted: item.startUTC,
      timezone: item.timezone,
    });
  };
  return (
    <Grid2
      container
      sx={{ display: 'flex', flexDirection: 'column' }}
      wrap="wrap">
      {selectedSlots.map((item, index) => (
        <Grid2 key={item.id || index} size={12}>
          <Box
            sx={{
              m: 1,
            }}
            textAlign="center">
            <Paper
              key={item.id || index}
              data-testid={`slot-${item.id || index}`}
              sx={
                index === selectedSlotIndex
                  ? {
                      backgroundColor: '#9bc2d1',
                      color: 'white',
                      margin: 1,
                      padding: 1,
                    }
                  : item.available
                  ? {
                      backgroundColor: '#12a14b',
                      color: 'white',
                      cursor: 'pointer',
                      margin: 1,
                      padding: 1,
                    }
                  : {
                      backgroundColor: 'grey',
                      color: 'white',
                      margin: 1,
                      padding: 1,
                    }
              }
              onClick={() => handleSelectSlot({ index, item })}>
              {DateTime.fromISO(item.startUTC || '')
                .setZone(item.timezone || 'local')
                .toFormat('HH:mm')}
              {` (${TimeDurationFormatter(item.duration || 0, translate)}) `}
              {item.price ? (
                <>
                  {index !== selectedSlotIndex &&
                    item.available &&
                    `${item.currency} `}
                  {index === selectedSlotIndex
                    ? translate('coreUi.slot.selected').toUpperCase()
                    : item.available
                    ? MoneyFormattedUtils(item.price, i18n.language)
                    : translate('coreUi.slot.notAvailable')}{' '}
                  per person
                </>
              ) : (
                'FREE'
              )}
            </Paper>
          </Box>
        </Grid2>
      ))}
    </Grid2>
  );
};

export default Slots;
